import { fetchAPI } from "./baseApi";

const PAGE_ENDPOINTS = {
  contact: "/contact/page",
  donations: "/donations/page",
  homepage: "/homepage/page",
  members: "/members/page",
  "open-source": "/open-source/page",
  partners: "/partners/page",
  publications: "/publications/page",
  research: "/research/page",
  webinars: "/webinars/page",
};

export async function getPageContent(pageKey) {
  const endpoint = PAGE_ENDPOINTS[pageKey];
  if (!endpoint) {
    throw new Error("Unknown page key");
  }
  return fetchAPI(endpoint, {
    method: "GET",
  });
}

export async function updatePageContent(pageKey, data) {
  const endpoint = PAGE_ENDPOINTS[pageKey];
  if (!endpoint) {
    throw new Error("Unknown page key");
  }
  return fetchAPI(endpoint, {
    method: "PUT",
    body: JSON.stringify(data),
  });
}
